// Navegadores com armazenamento bloqueado (modo restrito, webviews de apps) lançam
// SecurityError ao acessar localStorage/sessionStorage e quebram o site. Usa memória como fallback.
const makeMemoryStorage = () => {
  const data = new Map();
  return {
    getItem: (k) => (data.has(String(k)) ? data.get(String(k)) : null),
    setItem: (k, v) => { data.set(String(k), String(v)); },
    removeItem: (k) => { data.delete(String(k)); },
    clear: () => { data.clear(); },
    key: (i) => Array.from(data.keys())[i] ?? null,
    get length() { return data.size; },
  };
};

if (typeof window !== 'undefined') {
  ['localStorage', 'sessionStorage'].forEach((name) => {
    try {
      window[name].getItem('__mmr_probe__');
    } catch (e) {
      try {
        Object.defineProperty(window, name, { value: makeMemoryStorage(), configurable: true });
      } catch (_) { /* sem alternativa */ }
    }
  });
}
